import Card from 'food-benefit.module/common/domain/models/foodBenefitCard';

class cardRowDataFormatter {
  static assemble(data) {
    let cardArray = formatCards(data);
    return cardArray;
  }

}

function formatCards(rawData) {
  let cards = [];
  for (let key in rawData.foodBenefitPeriods) {
    let obj = rawData.foodBenefitPeriods[key];
    obj.id = rawData.employeeProfile.employeeId;
    cards.push(new Card(obj));
  }

  return cards;
}

export default cardRowDataFormatter;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/domain/formatters/cardRowDataFormatter.js